var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "render-short-youtube",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _c("div", { staticClass: "header-app" }, [
        _vm._v("\n        Shorts\n    "),
      ]),
      _c(
        "div",
        { staticClass: "reel-content", on: { click: _vm.clickOnPost } },
        [
          _vm._l(
            _vm.medias
              .filter((m) => m.info.type.startsWith("video/"))
              .slice(0, 1),
            function (media) {
              return _vm.medias.length
                ? _c("video", {
                    key: media.id,
                    attrs: {
                      autoplay: true,
                      loop: "",
                      playsinline: "",
                      preload: "metadata",
                      src: media.url,
                      type: media.info.type,
                    },
                    domProps: { muted: _vm.videoMuted },
                  })
                : _vm._e()
            }
          ),
          _c("div", { staticClass: "nav-lateral" }, [
            _c("div", { staticClass: "like" }, [
              _c(
                "svg",
                {
                  attrs: {
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "auto",
                    fill: "#FFF",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M8 21V9.282c0-.834.26-1.647.745-2.325L13 1l.551.331c1.153.691 1.705 2.065 1.351 3.362L14 8h5.192c.827 0 1.609.376 2.125 1.022.711.888.795 2.125.209 3.101L21 13l.165.413c.519 1.296.324 2.769-.514 3.885l-.151.202v.5c0 1.657-1.343 3-3 3H8ZM4.5 9C3.672 9 3 9.672 3 10.5v9c0 .828.672 1.5 1.5 1.5H7V9H4.5Z",
                    },
                  }),
                ]
              ),
              _c("p", [_vm._v("J'aime")]),
            ]),
            _c("div", { staticClass: "dislike" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "auto",
                    fill: "#FFF",
                    viewBox: "0 0 24 24",
                    width: "auto",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M16 3v11.718c0 .834-.26 1.647-.745 2.325L11 23l-.551-.331c-1.153-.691-1.705-2.065-1.351-3.362L10 16H4.808c-.827 0-1.609-.376-2.125-1.022-.711-.888-.795-2.125-.209-3.101L3 11l-.165-.413c-.519-1.296-.324-2.769.514-3.885L3.5 6.5V6c0-1.657 1.343-3 3-3H16Zm3 12c1.105 0 2-.895 2-2V5c0-1.105-.895-2-2-2h-2v12h2Z",
                    },
                  }),
                ]
              ),
              _c("p", [_vm._v("Je n...pas")]),
            ]),
            _c("div", { staticClass: "comment" }, [
              _c(
                "svg",
                {
                  attrs: {
                    height: "auto",
                    viewBox: "0 0 24 24",
                    width: "auto",
                    fill: "#FFF",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "clip-rule": "evenodd",
                      d: "M21 5c0-1.105-.895-2-2-2H5c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h12l3.146 3.146c.315.315.854.092.854-.353V5ZM7 9c0-.552.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1Zm1 3c-.552 0-1 .448-1 1s.448 1 1 1h5c.552 0 1-.448 1-1s-.448-1-1-1H8Z",
                      "fill-rule": "evenodd",
                    },
                  }),
                ]
              ),
              _c("p", [_vm._v("0")]),
            ]),
            _c("div", { staticClass: "send" }, [
              _c(
                "svg",
                {
                  attrs: {
                    height: "auto",
                    viewBox: "0 0 24 24",
                    width: "auto",
                    fill: "#FFF",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "m13.202 3.368 9.438 7.865c.48.4.48 1.137 0 1.537l-9.438 7.865c-.652.543-1.64.08-1.64-.768V16H9.957c-2.778 0-5.406 1.263-7.141 3.432-.304.38-.912.086-.803-.388l1.118-4.843C3.968 10.572 7.2 8 10.926 8h.636V4.137c0-.848.989-1.311 1.64-.769Z",
                    },
                  }),
                ]
              ),
              _c("p", [_vm._v("Partager")]),
            ]),
            _vm.pages.length
              ? _c("div", { staticClass: "square" }, [
                  _c("img", { attrs: { src: _vm.pages[0].avatar } }),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "info-reel" }, [
            _c("div", { staticClass: "page" }, [
              _c(
                "div",
                {
                  staticClass: "images",
                  class: { multiple: _vm.pages.length > 1 },
                },
                [
                  _vm._l(_vm.pages.slice(0, 3), function (page, index) {
                    return _c("img", {
                      key: index,
                      attrs: { src: page.avatar },
                      on: {
                        click: () => {
                          page.iconEdited
                            ? _vm.$emit("clickPage", page.id)
                            : _vm.openYoutubePage(page)
                        },
                      },
                    })
                  }),
                  _vm.pages.length > 3
                    ? _c("div", { staticClass: "count" }, [
                        _vm._v(
                          "\n                        +" +
                            _vm._s(_vm.pages.length - 3) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _c("div", { staticClass: "names" }, [
                _vm.pages.length <= 1
                  ? _c(
                      "p",
                      {
                        staticClass: "page-name",
                        on: {
                          click: function ($event) {
                            return _vm.openYoutubePage(_vm.pages[0])
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.pages[0].name))]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm.textTranslate
              ? _c("div", {
                  staticClass: "description-reel",
                  class: { "cut-content": !_vm.fullContent },
                  domProps: { innerHTML: _vm._s(_vm.textTranslate) },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.toggleFullContent.apply(null, arguments)
                    },
                  },
                })
              : _vm._e(),
          ]),
          _c("div", {
            key: _vm.videoMuted ? "no-sound" : "sound",
            class: _vm.videoMuted ? "no-sound" : "sound",
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }